import { useTranslation } from 'react-i18next';

// Cross-promo card for the PROTOSchem app, shown under the hero DOWNLOAD button.
// Styles live in public/css/protoschem-card.css.
export const ProtoSchemPromo = (props) => {
  const { t } = useTranslation();

  // GA4: track hero cross-promo clicks. Guarded so it never throws if gtag is blocked.
  const handleClick = () => {
    if (window.gtag) {
      window.gtag('event', 'select_promotion', {
        promotion_id: 'protoschem_launch',
        promotion_name: 'PROTOSchem hero card',
        creative_slot: 'hero_download_area',
      });
    }
  };

  return (
    <a
      className='ps-promo'
      href='https://play.google.com/store/apps/details?id=com.proto.schem&utm_source=protosimulator&utm_medium=hero_card&utm_campaign=protoschem_launch&referrer=utm_source%3Dprotosimulator%26utm_medium%3Dhero_card%26utm_campaign%3Dprotoschem_launch'
      target='_blank'
      rel='noopener noreferrer'
      aria-label={t('ProtoSchemPromo.ariaLabel')}
      onClick={handleClick}
    >
      <img className='ps-promo__icon' src='/img/protoschem-icon.webp' alt='' width='60' height='60' loading='lazy' />
      <span className='ps-promo__text'>
        <span className='ps-promo__kicker'>{t('ProtoSchemPromo.kicker')}</span>
        <span className='ps-promo__title'>PROTOSchem</span>
        <span className='ps-promo__desc'>{t('ProtoSchemPromo.description')}</span>
      </span>
      {/* U+FE0E keeps ▶ as a text glyph instead of an emoji */}
      <span className='ps-promo__cta' aria-hidden='true'>
        <span className='ps-promo__cta-label'>{t('ProtoSchemPromo.cta')}</span>
        {'▶︎'}
      </span>
    </a>
  );
};
